import { useQueryClient, useMutation } from "@tanstack/react-query";

import { ResponseWithStatus } from "../types";

import { Conditional } from "@/types/conditionals";
import { jsonAuthHeaders } from "@/utils/headers";
import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";

interface Message {
  loc: string[];
  msg: string;
  type: string;
}

export const useSetWorkflowReleaseLabelGroup = (
  userToken: string,
  workspace_id: number,
  workflowReleaseLabelGroupId: string,
) => {
  const queryClient = useQueryClient();

  return useMutation<ResponseWithStatus<Message[]>, Error, Conditional[]>(
    conditionals =>
      fetch(`${ENDPOINTS.workflow_release_label_groups}/${workflowReleaseLabelGroupId}`, {
        method: "PUT",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          workspace_id,
          conditionals,
        }),
      }).then(handleResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.workflow_release_label_groups]);
      },
    },
  );
};
